export function validateResponseStatus(response) {
  if (response?.message === "Invalid token") {
    // If status code is 403, clear localStorage and redirect to login page
    clearLocalStorageAndRedirect();
  } else if (response?.error) {
    // Handle other errors (e.g., network errors)
    console.error("Error fetching user data:", response);
  }

  //   if (error.response && error.response.status === 403) {
  //     // If status code is 403, clear localStorage and redirect to login page
  //     clearLocalStorageAndRedirect();
  //   } else {
  //     // Handle other errors (e.g., network errors)
  //     console.error("Error fetching user data:", error);
  //   }
}

export function clearLocalStorageAndRedirect() {
  // Clear the localStorage
  localStorage.clear();

  // Redirect to the login page
  window.location.href = "/"; // Assuming '/login' is your login page's route
}
